const portfolioTrackerParser = portfolioTracker => {
  return {
    amountInvested: portfolioTracker?.amount_invested,
    currentInvestedValue: portfolioTracker?.current_value,
    netGain: portfolioTracker?.net_gain,
    netIRR: portfolioTracker?.net_irr,
  }
}

// Returns the raw numeric portfolio metrics so the Overview hero can format them
// (big current value, change chip, composition bar ratios, KPI strip) itself.
// Data path is unchanged: OverviewDuck still calls this and stores the result under `portfolioTracker`.
export const portfolioTrackersParser = portfolioTracker => {
  return portfolioTrackerParser(portfolioTracker)
}
